import type { Table, ShapeStyle } from "../style";
import { Entity, type Parent } from "../tree";
import { Cache } from "../style";

// # Shape Base Class
// An entity with shape-specific styling
export abstract class ShapeBase<DataType> extends Entity<DataType> {
  //
  constructor(arg: CreateShape<DataType>) {
    super(arg);
    this.cache = this.makeCache(arg.table);
  }
  override readonly cache: Cache<ShapeStyle>;
  get style(): ShapeStyle {
    return this.cache.value;
  }
}

// # CreateShape
// Object-form constructor arguments
export type CreateShape<DataType> = {
  data: DataType;
  parent: Parent;
  table: Table<ShapeStyle>;
};
